"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var layout_1 = require("../_shared/components/layout");
var model_1 = require("../../model");
var LiveMapView_1 = require("./partial/LiveMapView");
var PortalPage_1 = require("../_shared/components/PortalPage");
require("./MapPage.scss");
var MapPage = /** @class */ (function (_super) {
    __extends(MapPage, _super);
    function MapPage(props) {
        var _this = _super.call(this, props) || this;
        _this.firstTimeLoad = true;
        return _this;
    }
    MapPage.prototype.componentWillReceiveProps = function (newProps) {
        if (!newProps.isLoadingMap && this.firstTimeLoad) {
            this.firstTimeLoad = false;
        }
    };
    MapPage.prototype.componentWillUnmount = function () {
        this.firstTimeLoad = true;
    };
    MapPage.prototype.render = function () {
        return (
        // disable the loading indicator for the realtime page because it blocks the map from moving or anything.
        React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_REALTIME, id: "map-page", hideHeader: true, isLoading: this.props.isLoadingMap && this.firstTimeLoad },
            React.createElement(layout_1.Row, { height: "100%" },
                React.createElement(layout_1.Column, null,
                    React.createElement(layout_1.Wrapper, { className: "map-legend", padding: "16px 16px 8px" },
                        React.createElement("span", null,
                            React.createElement("img", { src: (0, model_1.locationIcon)(model_1.PLACE_USER) }),
                            "Service Monteur"),
                        React.createElement("span", null,
                            React.createElement("img", { src: (0, model_1.locationIcon)(model_1.PlaceType.PROJECT) }),
                            "Projecten"),
                        React.createElement("span", null,
                            React.createElement("img", { src: (0, model_1.locationIcon)(model_1.PlaceType.SERVICE_ORDER) }),
                            "Service Order"),
                        React.createElement("span", null,
                            React.createElement("img", { src: (0, model_1.locationIcon)(model_1.PlaceType.OFFICE) }),
                            "Magazijnen/kantoren"),
                        React.createElement("span", null,
                            React.createElement("img", { src: (0, model_1.locationIcon)(model_1.PlaceType.SUPPLIER) }),
                            "Leveranciers")),
                    React.createElement(LiveMapView_1.default, { onSelectLocation: function (location) { return console.log('selecter ', location); } })))));
    };
    return MapPage;
}(React.Component));
var mapStateToProps = function (_) {
    return {
        isLoadingMap: _.reducer.locationsState.isUsersLoading || _.reducer.locationsState.isPlacesLoading,
        user: _.reducer.authentication.user,
    };
};
var mapDispatchToProps = function (dispatch) { return ({}); };
var Container = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(MapPage);
exports.default = (0, react_router_1.withRouter)(Container);
